// src/components/MapComponent.js
import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet-routing-machine';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import axios from 'axios';
import './MapComponent.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const getRouteData = async (start, end) => {
  const startCoords = `${start.lng},${start.lat}`;
  const endCoords = `${end.lng},${end.lat}`;
  const url = `http://localhost:6000/route/v1/driving/${startCoords};${endCoords}?overview=full&geometries=polyline&steps=true&generate_hints=false`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};


const MapComponent = ({ start, end }) => {
  const mapRef = useRef();
  const [routeData, setRouteData] = useState(null);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    const getRoute = async () => {
      const data = await getRouteData(start, end);
      setRouteData(data);

      // Create a new routing control
      const routingControl = L.Routing.control({
        waypoints: [
          L.latLng(start.lat, start.lng),
          L.latLng(end.lat, end.lng)
        ],
        routeWhileDragging: true,
        router: L.Routing.osrmv1({
          serviceUrl: 'http://localhost:6000/route/v1/driving/{s};{e}?overview=full&geometries=polyline&steps=true&generate_hints=false',
        }),
      });

      // Add the routing control to the map
      routingControl.addTo(map);

      // Store the routing control in the map reference
      map.routingControl = routingControl;

      return () => {
        routingControl.remove(); // Clean up on unmount
      };
    };

    getRoute();
  }, [start, end]);

  return (
    <MapContainer
      center={[1.3521, 103.8198]}
      zoom={13}
      scrollWheelZoom={true}
      style={{ height: '500px', width: '800px' }}
      ref={mapRef}
    >
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
      />
      <Marker position={[start.lat, start.lng]}>
        <Popup>Start Point</Popup>
      </Marker>
      <Marker position={[end.lat, end.lng]}>
        <Popup>End Point</Popup>
      </Marker>
      {routeData && (
        <div>
          <h2>Route Details</h2>
          <p>Distance: {routeData.routes[0].summary.distance} meters</p>
          <p>Duration: {routeData.routes[0].summary.duration} seconds</p>
        </div>
      )}
    </MapContainer>
  );
};

export default MapComponent;
